import {
  directoryStatusSchema,
  directorySyncQueuedSchema,
  type DirectorySource,
} from '@gb-ticket/shared-types';
import { useMutation, useQuery } from '@tanstack/react-query';

import { apiFetch } from '@/lib/api';

export const directoryStatusQueryKey = ['directory', 'status'] as const;

export function useDirectoryStatus() {
  return useQuery({
    queryKey: directoryStatusQueryKey,
    queryFn: () => apiFetch('/directory/status', directoryStatusSchema),
    refetchOnWindowFocus: true,
  });
}

export function useStartDirectorySync() {
  return useMutation({
    mutationFn: (source: DirectorySource) =>
      apiFetch('/directory/sync', directorySyncQueuedSchema, {
        method: 'POST',
        body: JSON.stringify({ source }),
      }),
  });
}
